import {
  getMarketById,
  getMarketIdByCountry,
  getMarketByCountry,
  getDefaultMarket
} from './gns-market.js';

console.log('[GNS] Main loaded');

/**
 * ==========================================================
 * GNS Market Logic Test
 * ==========================================================
 */

console.log('[GNS TEST] getMarketById("us")');
console.log(getMarketById('us'));

console.log('[GNS TEST] getMarketIdByCountry("US")');
console.log(getMarketIdByCountry('US'));

console.log('[GNS TEST] getMarketByCountry("HU")');
console.log(getMarketByCountry('HU'));

console.log('[GNS TEST] getMarketByCountry("PL")');
console.log(getMarketByCountry('PL'));

console.log('[GNS TEST] getMarketByCountry("CN")');
console.log(getMarketByCountry('CN'));

console.log('[GNS TEST] getMarketByCountry("XX")');
console.log(getMarketByCountry('XX'));

console.log('[GNS TEST] getDefaultMarket()');
console.log(getDefaultMarket());